import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

const mutation = graphql`
  mutation uploadMSWordMutation($input: UploadMSDocumentMutationInput!) {
    uploadMsword(input: $input) {
      ok
      reasons
      taskId
    }
  }
`;

const uploadMSWordDocument = (
  environment,
  variables,
  uploadables,
  callback
) => {
  commitMutation(environment, {
    mutation,
    variables,
    uploadables,
    onCompleted: (response, errors) => {
      callback(response, errors);
    },
    onError: err => {
      throw new Error(err);
    }
  });
};

export default uploadMSWordDocument;
